import React from 'react';

export default function DailyAudio(props) {

  return (
    <>
        {props.sound.map((ele, index) => (
        <li key={index}>
                <a href="/">
                  <audio controls>
                    <source src={`${ele.audio['preview-hq-mp3']}`} type="audio/mp3"/>
                    <source src={`${ele.audio['preview-hq-ogg']}`} type="audio/ogg"/>
                  </audio>
                </a>
        </li>
        ))
    }
    </>
  )
}
